/* eslint-disable @nx/enforce-module-boundaries */
import { IconButton, Toast } from '@chakra-ui/react';
import {
  DeleteIcon,
  EditIcon,
  MakeCoverPictureIcon,
  MakeProfilePictureIcon,
  ReportIcon,
  TagIcon,
} from '@mybridge/icons';

import { useDisclosure } from '@mybridge/ui/hooks';
import { Menu, MenuButton, MenuItem, MenuList } from '@mybridge/ui/menu';
import { useContext, useMemo, useState } from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Box,
} from '@mybridge/ui';
import { DownloadIcon } from '@chakra-ui/icons';
import { UserProfileIcon } from '@mybridge/icons/chat-icons';
import ImageUploader from 'v4/components/image-uploader';
import { useForm } from 'react-hook-form';
import {
  getUserProfileInfo,
  userProfileAddInfo,
} from 'v4/store/actions/user-profile.actions';
import { useDispatch, useSelector } from 'react-redux';
import { async } from '@firebase/util';
import { PostBoxBlockReportModal } from 'v4/components/post/post-actions-modals/block-report';
import { PostBoxContext, usePostBoxContext } from 'v4/components/post/context';
import { PostBoxDeleteModal } from 'v4/components/post/post-actions-modals/delete-post';
import { updatePost } from 'v4/store/actions/post.actions';
import { useMutation } from '@tanstack/react-query';
import { patchCompanyInfo } from 'v4/store/actions/companyPages.actions';
import { MyProfileContext, useMyProfileContext } from 'v4/components/profile/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';


const PhotoActionsMenu = ({
  selectedImgPost,
  selctedImage,
  isPhotos,
  isActiveIndex,
  imageData,
  companyPageDetailId,
  company,
}) => {
  const myProfileContext = useMyProfileContext({});
  const {
    userProfileInfo,
    refetchAgregatedPhotos,
    refetchYourPhotos,
    refetchyourVideos,
    refetchPhotosOfyou,
    refetchvideosOfYou,
    removeTagResult,
    removeTagLoading,
    removeTag,
  } = myProfileContext ?? {}
  const { t } = useTranslator();
  const menuDisc = useDisclosure();
  const [isOpen, setIsOpen] = useState(false);
  const [cropType, setCropType] = useState();
  const [loading, setLoading] = useState(null);
  const [src, setSrc] = useState(null);
  const [image, setImage] = useState(null);
  const [fileData, setFileData] = useState(undefined);
  const blockReportModal = useDisclosure();
  const deletePostModal = useDisclosure();
  const dispatch = useDispatch();
  
  
  const handleRefetchData = () => {
    if (selectedImgPost?.company?.name?.length > 0) {
      refetchAgregatedPhotos?.({
        company: selectedImgPost?.company?.id,
      });
      refetchPhotosOfyou?.({ company: selectedImgPost?.company?.id });
      refetchYourPhotos?.({ company: selectedImgPost?.company?.id });
      refetchyourVideos?.({ company: selectedImgPost?.company?.id });
      refetchvideosOfYou?.({ company: selectedImgPost?.company?.id });
    } else {
      refetchAgregatedPhotos?.({ user: userProfileInfo.slug });
      refetchPhotosOfyou?.({ slug: userProfileInfo.slug });
      refetchYourPhotos?.({ user: userProfileInfo.slug });
      refetchyourVideos?.({ user: userProfileInfo.slug });
      refetchvideosOfYou?.({ user: userProfileInfo.slug });
    }
  };
  
  const { mutate: editPost, isLoading: editLoading } = useMutation(
    async (body) => {
      return dispatch(updatePost({ id: selectedImgPost?.id, formData: body }));
    },
    {
      onSuccess: (data) => {
        handleRefetchData();
      },
      onError: (error) => {
        Toast({ title: 'Error while Delete Photo!', status: 'error' });
      },
    }
  );
  const uploadCropedImg = (img) => {
    if(company)
    {
    const payload = {
      companyId: companyPageDetailId,
    };

    if (cropType === 'profilePhoto') {
      payload['image'] = img;
    } else {
      payload['banner_image'] = img;
    }
    payload['show_on_feed'] = true
     dispatch(patchCompanyInfo(payload)).then((res) => {
      dispatch(getUserProfileInfo());
      setLoading(false);
      setIsOpen(false);
    })
    .catch((e) => {
      console.warn('err while updating photo');
      setLoading(false);
      setIsOpen(false);
    });
  }else{
    const formData = {};
    if (cropType === 'profilePhoto') {
      formData['profile_pic'] = img;
    } else {
      formData['profile_banner_pic'] = img;
    }
    setLoading(true);
    dispatch(userProfileAddInfo(formData, true))
      .then((res) => {
        dispatch(getUserProfileInfo());
        setLoading(false);
        setIsOpen(false);
      })
      .catch((e) => {
        console.warn('err while updating photo');
        setLoading(false);
        setIsOpen(false);
      });
}
  };

  const handleDownload = async (photoUrl, fileName) => {
    try {
      // Fetch the image
      const response = await fetch(photoUrl);
      if (!response.ok) throw new Error('Network response was not ok');
      // Convert the response to a blob
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Failed to download the image:', error);
    }
  };

  const hanndleSetUrlInUploader = async (imageUrl, imgType) => {
    setLoading(true);
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const file = new File([blob], 'nature-image.jpeg', { type: blob.type });
    setFileData(file);
    const url = URL.createObjectURL(file);
    setSrc(url);
    try {
      if (typeof window === 'undefined') return;
      const img = new window.Image();
      img.onload = function () {
        setImage(img);

      };
      img.src = url;
    } catch (e) {
      console.error(e);
    }
    setCropType(imgType);
    setTimeout(() => {
      setIsOpen(true);
      setLoading(false);
    }, 50);
  };

  const handleRemoveTag = (postId) => {
    removeTag(postId);
    // handleRefetchData();
  };

  const handleDeleteFile = async (post, media) => {
    const formData = new FormData();
    const newPostMedia = post?.media?.filter((obj) => obj.id !== media.id);
    if (post?.companyId) {
      formData.append('company_id', post?.companyId);
    }
    formData.append('visibility', post?.visibility || 0);
    formData.append('reply_control', post?.replyControl || 0);

    if (post?.content?.length > 0) {
      formData.append('content', post?.content);
    }

    if (post?.feeling?.id) {
      formData.append('feelings_id', post?.feelings?.id);
    }

    formData.append('media_updated', true);
    const newdata = newPostMedia.map((item) => item.id);
    formData.append('media_ids', [...newdata]);

    editPost(formData);
    // handleRefetchData()
  };

  const photosOfYouActions = useMemo(
    () => [
      {
        title: t('profilePhotosVideos.removeTag') || 'Remove Tag',
        icon: <TagIcon width={20} height={20} />,
        onClick: () => {
          handleRemoveTag(selectedImgPost?.id);
        },
      },
      {
        title: t('profilePhotosVideos.download') || 'Download',
        icon: <DownloadIcon width="23px" height="20px" />,
        onClick: () => {
          handleDownload(imageData?.file, 'photo.jpg');
        },
      },
      {
        title: t('profilePhotosVideos.makeProfilePicture') || 'Make profile picture',
        icon: <MakeProfilePictureIcon width={20} height={20} />,
        onClick: () => {
          hanndleSetUrlInUploader(imageData?.file, 'profilePhoto');
        },
      },
      {
        title: t('profilePhotosVideos.makeCoverPhoto') || 'Make cover photo',
        icon: <MakeCoverPictureIcon width={20} height={20} />,
        onClick: () => {
          hanndleSetUrlInUploader(imageData?.file, 'profile_banner_pic');
        },
      },
      {
        title: t('profilePhotosVideos.report') || 'Report',
        icon: <ReportIcon width={20} height={20} />,
        onClick: () => {
          blockReportModal.onOpen();
        },
      },
    ],
    []
  );

  const yourPhotosActions = useMemo(
    () => [
      {
        title: t('profilePhotosVideos.deletePhoto') || 'Delete photo',
        icon: <DeleteIcon width={20} height={20} />,
        onClick: () => {
          selectedImgPost?.media?.length > 1
            ? handleDeleteFile(selectedImgPost, imageData)
            : deletePostModal?.onOpen();
        },
      },
      {
        title: t('profilePhotosVideos.download') || 'Download',
        icon: <DownloadIcon width="23px" height="20px" />,
        onClick: () => {
          handleDownload(imageData?.file, 'photo.jpg');
        },
      },
      {
        title: t('profilePhotosVideos.makeProfilePicture') || 'Make profile picture',
        icon: <MakeProfilePictureIcon width={20} height={20} />,
        onClick: () => {
          hanndleSetUrlInUploader(imageData?.file, 'profilePhoto');
        },
      },
      {
        title: t('profilePhotosVideos.makeCoverPhoto') || 'Make cover photo',
        icon: <MakeCoverPictureIcon width={20} height={20} />,
        onClick: () => {
          hanndleSetUrlInUploader(imageData?.file, 'profile_banner_pic');
        },
      },
    ],
    []
  );

  const videosOfYouActions = useMemo(
    () => [
      {
        title: t('profilePhotosVideos.removeTag') || 'Remove Tag',
        icon: <TagIcon width={20} height={20} />,
        onClick: () => {
          handleRemoveTag(selectedImgPost?.id);
        },
      },

      {
        title: t('profilePhotosVideos.report') || 'Report',
        icon: <ReportIcon width={20} height={20} />,
        onClick: () => {
          blockReportModal.onOpen();
        },
      },
    ],
    []
  );

  const yourVideosActions = useMemo(
    () => [
      {
        title: t('profilePhotosVideos.deleteVideo') || 'Delete video',
        icon: <DeleteIcon width={20} height={20} />,
        onClick: () => {
          selectedImgPost?.media?.length > 1
            ? handleDeleteFile(selectedImgPost, imageData)
            : deletePostModal?.onOpen();
        },
      },
      {
        title: t('profilePhotosVideos.download') || 'Download',
        icon: <DownloadIcon width="23px" height="20px" />,
        onClick: () => {
          handleDownload(imageData?.file, 'video.mp4');
        },
      },
    ],
    []
  );

  const postBoxContext = usePostBoxContext({
    post: selectedImgPost,
    // initialFetchComments: showComments,
  });

  const MenuData = useMemo(() => {
    if (isPhotos) {
      if (isActiveIndex === 0) {
        return photosOfYouActions;
      }
      return yourPhotosActions;
    } else {
      if (isActiveIndex === 0) {
        return videosOfYouActions;
      }
      return yourVideosActions;
    }
  }, []);

  const HandleDeleteComplete = () => {
    deletePostModal?.onClose();

    setTimeout(() => {
      
      handleRefetchData();
    }, 2000);
  };

  return (
    <>
      <PostBoxContext.Provider
        value={{
          ...(postBoxContext ?? {}),
        }}
      >
        <Menu {...menuDisc} closeOnSelect={true} zIndex="0">
          <MenuButton
            as={IconButton}
            icon={<EditIcon color="white" width="14px" height="14px" />}
            size="xs"
            variant="ghost"
            sx={{
              _hover: { background: 'transparent' },
              _focus: { boxShadow: 'none' },
              _active: { background: 'transparent' },
            }}
          ></MenuButton>

          <Portal>
            <MenuList>
              {MenuData?.map?.((action, index) => {
                return (
                  <MenuItem
                    key={index}
                    // icon={action.icon}
                    onClick={action.onClick}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      {action.icon && (
                        <Box sx={{ mr: 2 }} style={{width:"20px"}}>
                          {action.icon}
                        </Box>
                      )}
                      {action?.title}
                    </Box>
                  </MenuItem>
                );
              })}
            </MenuList>
          </Portal>
        </Menu>
        <Modal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          isCentered
          size="4xl"
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color="#3D5A80" fontSize="lg">
              {t('profilePhotosVideos.addPhoto') || 'Add Photo'}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <ImageUploader
                _src={src}
                _image={image}
                _fileData={fileData}
                noUploadRequire={true}
                cropType={cropType}
                isLoading={loading}
                uploadCropedImg={uploadCropedImg}
                onProfilePostData={()=><></>}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
        {blockReportModal?.isOpen ? (
          <PostBoxBlockReportModal {...blockReportModal} />
        ) : null}

        {deletePostModal?.isOpen ? (
          <PostBoxDeleteModal
            isFromProfile={true}
            onDeleteComplete={() => HandleDeleteComplete()}
            {...deletePostModal}
          />
        ) : (
          ''
        )}
      </PostBoxContext.Provider>
    </>
  );
};
export default PhotoActionsMenu;
